<div class="select-wrap" [class.readonly]="isInViewMode">
    <h4 class="form-label">{{ title }}</h4>

    <div class="dropdown-wrapper" appMousedownOutside (mousedownOutside)="showUserList = false; searchParam = '';">
        <ul class="selected-user-groups-list disp-flex" (click)="toggleUserList()">
            @for (selectedUser of selectedUsers; let i = $index; track i) {
                <li class="selected-user-group">
                    @if (selectedUser.privilege === permission) {
                        <span [ccTooltip]="selectedUser.tooltipDescription">
                            {{ selectedUser.name.toUpperCase() }}
                            <label
                                class="icon-close1"
                                (click)="removeUserPermission($event, i)">
                            </label>
                        </span>
                    }
                </li>
            }

            <li class="dropdown-arrow">
                <span class="icon-arrow-down"></span>
            </li>
        </ul>

        @if (showUserList) {
            <div class="dropdown">
                <div class="dropdown-user-select">
                    <ul class="top-menu clearfix">
                        <li class="tab-list">
                            <span class="selected" [ngClass]="{'selected':(selectedTab === 'ALL')}" (click)="selectedTab = 'ALL'">All</span>
                        </li>

                        <li class="tab-list">
                            <span [ngClass]="{'selected':(selectedTab === 'USER')}" (click)="selectedTab = 'USER'">Individual</span>
                        </li>

                        <li class="tab-list">
                            <span [ngClass]="{'selected':(selectedTab === 'TEAM')}" (click)="selectedTab = 'TEAM'">Teams</span>
                        </li>
                    </ul>

                    <div class="search-box">
                        <span class="icon-search1"></span>

                        <input
                            appAutoFocus
                            type="search"
                            name="searchParam"
                            placeholder="Type username or email"
                            autocomplete="off"
                            [(ngModel)]="searchParam"
                            [focus]="true"
                        />

                        <button class="fill-btn" type="button" (click)="applySelectedUsers($event)">Apply</button>
                    </div>

                    <ul class="search-list">
                        @for (user of userList | userListFilter: selectedTab : searchParam; track $index) {
                            <li
                                class="checkbox"
                                [ngClass]="{'selected': user.selected}"
                            >
                                <cc-checkbox
                                    class="checkbox-custom-label clearfix"
                                    [label]="!searchParam ? user.name : ''"
                                    [(value)]="user.selected"
                                    (valueChange)="onUserSelect(user.name)"
                                >
                                    <label
                                        class="highlight"
                                        [innerHTML]="searchParam && user.name | highlight: searchParam"
                                    >
                                    </label>
                                    @if (user.email) {
                                        <span
                                            class="email"
                                            [innerHTML]="searchParam && user.email | highlight: searchParam"
                                            [ccTooltip]="{ message: user.email, onlyOnTruncated: true }"
                                        >
                                        </span>
                                    }
                                </cc-checkbox>

                                <span class="user-text" [ngClass]="{'noAccess': !user.privilege}">
                                    {{ user.privilege ? user.displayPrivilege : 'No Access' }}
                                </span>
                            </li>
                        }
                    </ul>
                </div>
            </div>
        }
    </div>
</div>
